import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContentService } from '../content/content.service';
import { TranslateService } from '../translate/translate.service';
import { AuthService } from '../auth/auth.service';
import { IntervalService } from '../interval/interval.service';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {

  public $initialized = new BehaviorSubject<boolean>(false);

  public $languageReady = new BehaviorSubject<boolean>(false);

  public $metaPackage = new BehaviorSubject<any>(null);
  public $mainPackage = new BehaviorSubject<any>(null);
  public $ticker = new BehaviorSubject<any>(null);
  public $breakingNews = new BehaviorSubject<any>(null);
  public $centerWidgetScreensavers = new BehaviorSubject<any[]>(null);
  public $navigationScreensavers = new BehaviorSubject<any[]>(null);

  public $currentLanguage = new BehaviorSubject<any>('de');
  public currentLanguage = 'de';

  public $serverError = new BehaviorSubject<boolean>(false);

  public $checksum = new BehaviorSubject<string>(null);

  public $filter = new BehaviorSubject<any>(null);
  public $filterCounter = new BehaviorSubject<any>(null);
  public $filterIsSingleSelect = new BehaviorSubject<any>(false);
  public $selectedFilters = new BehaviorSubject<any>(null);

  public $showNavigation = new BehaviorSubject<any>(true);
  public $selectedPartner = new BehaviorSubject<any>(null);
  public $updateNavigation = new BehaviorSubject<any>(null);

  public $initialItemId = new BehaviorSubject<any>(null);
  public $currentSearchValue = new BehaviorSubject<string>('');

  public $resetInfoscreenIndexes = new BehaviorSubject<number>(null);

  public appState: any;

  private languageOrder = ['de', 'en', 'it', 'fr'];
  public availableLanguages = (window['forceAvailableLanguages'] ? window['forceAvailableLanguages'].split(',') : ['de']).sort((a, b) => {
    return this.languageOrder.indexOf(a) - this.languageOrder.indexOf(b);
  });

  constructor(private contentService: ContentService, private translateService: TranslateService, private auth: AuthService) {
    this.initMetaPackage();
    this.initChecksum().then(() => {
    });

    this.initSession();

    this.$currentLanguage.subscribe(lang => {
      this.initLanguageContent(lang);
      IntervalService.set('messenger', () => {
        return this.contentService.loadPackageLog().then(packageLog => {
          if (this.$checksum.getValue() !== (packageLog.checksum2 || packageLog.checksum)) {
            this.$checksum.next((packageLog.checksum2 || packageLog.checksum));
            this.initLanguageContent(lang);
          }
        }).catch(err => {
          console.warn(err);
        });
      }, 1000 * 60);
    });
  }

  private static initTickerBreakingNews(tickerBreakingNewsElement: any, target: BehaviorSubject<any>) {
    target.next(tickerBreakingNewsElement);
  }

  public updateLanguage(lang) {
    this.$currentLanguage.next(lang);
    this.translateService.loadTranslation(lang).then(() => {
    });
  }

  public resetFilter() {
    this.$filter.next(null);
    this.$filterCounter.next(null);
    this.$filterIsSingleSelect.next(false);
    this.$selectedFilters.next(null);
  }

  private initSession() {
    /* get socket connection - socket not used currently */
    this.auth.initSession();
    this.auth.$activeSession.subscribe(session => {
      this.$initialized.next(true);
      if (!session) {
        return;
      }
    });
  }

  private initMetaPackage() {
    /* $metaPackage holds basic information about the package like title, logo ... */
    this.contentService.initMeta().then(jsonMeta => {
      if (jsonMeta) {
        this.$metaPackage.next(jsonMeta);
      } else {
        setTimeout(() => {
          this.initMetaPackage();
        }, 60000);
      }
    }).catch(err => {
      console.error('init meta package error:', err);
      this.$serverError.next(true);
      setTimeout(() => {
        this.initMetaPackage();
      }, 60000);
    });
  }

  private initChecksum() {
    return this.contentService.loadPackageLog().then(packageLog => {
      this.$checksum.next((packageLog.checksum2 || packageLog.checksum));
    }).catch(err => {
      console.warn(err);
      // todo no connection to the server - should we get it from cache?
      // interval to check again? ...
      this.$serverError.next(true);
    });
  }

  private initLanguageContent(language: string) {
    this.$ticker.next(null);
    this.$breakingNews.next(null);
    /* get $mainPackage by language */
    this.translateService.loadTranslation(language).then(() => {
      this.$languageReady.next(true);
      this.contentService.loadPackage(language).then(jsonPackage => {
        if (jsonPackage) {
          if (jsonPackage && jsonPackage.entries && jsonPackage.entries.entryCustomerInformation && jsonPackage.entries.entryCustomerInformation.detail && jsonPackage.entries.entryCustomerInformation.detail.translations) {
            let json = JSON.stringify(jsonPackage);
            json = json.replace(/%t:([^%]+)%/ig, function(match, transKey) {
              return jsonPackage.entries.entryCustomerInformation.detail.translations[transKey];
            });
            jsonPackage = JSON.parse(json);
          }
          this.$mainPackage.next(null);
          setTimeout(() => {
            this.$mainPackage.next(jsonPackage); /* parsed package data */
            if (jsonPackage.ticker && Object.keys(jsonPackage.ticker).length) {
              MessengerService.initTickerBreakingNews(jsonPackage.ticker, this.$ticker);
            }
            if (jsonPackage.breakingNews && Object.keys(jsonPackage.breakingNews).length) {
              MessengerService.initTickerBreakingNews(jsonPackage.breakingNews, this.$breakingNews);
            }
            if (!!jsonPackage.screensaver) {
              let entry = this.contentService.getEntry(jsonPackage.screensaver.entry);
              let centerWidgetScreensavers = [];
              let navigationScreensavers = [];
              for (let related of entry.related.entries) {
                let screensaverEntry = this.contentService.getEntry(related.id);
                if (screensaverEntry && screensaverEntry.detail && screensaverEntry.detail.isSlideShow) {
                  centerWidgetScreensavers.push(screensaverEntry);
                }
                if (screensaverEntry && screensaverEntry.detail && screensaverEntry.detail.isNavigationSlideshow) {
                  navigationScreensavers.push(screensaverEntry);
                }
              }
              this.$centerWidgetScreensavers.next(centerWidgetScreensavers);
              this.$navigationScreensavers.next(navigationScreensavers);
            }
          }, 500);
        }
        // todo no connection to the server - should we get it from cache?
      });
    });
  }
}
